import React, { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';
import axios from 'axios';
import CO_ManageData from '../../../CO_ManageData'; 
import BlockTerms from "../../BlockElements/BlockTerms";


const PayButton = ({pagetype, store}) => {
  let checkouturl = store.getState().checkoutsettings.checkoutSettings?.checkout_url || "";
  let checkoutnonce = store.getState().checkoutsettings.checkoutSettings?.checkout_nonce || "";
  const checkoutsteps = store.getState().checkoutsettings.checkoutSettings.checkout_steps;
  let mollieInstance = store.getState().selectedorderdata?.paymentmollieinstance || null;
  //let woocommerce_pay_order_before_submit = store.getState().checkouthooks.checkoutHooks?.woocommerce_pay_order_before_submit || "";
  let formData = CO_ManageData.prepareFormData();
  const [isValidating, setIsValidating] = useState(false);
  const [checkoutParams, setCheckoutParams] = useState(null);




useEffect(() => {
  // Prüfen, ob mollieInstance korrekt übergeben wird
  console.log('mollieInstance in PayButton:', mollieInstance);

      
  if (document.readyState === 'complete') {
    console.log("mollie load 1");
    if (mollieInstance !== null && mollieInstance !== undefined) {
      console.log('mollieInstance in PayButton 2:', mollieInstance);
    }
  } else {
    console.log("mollie load 2");
    window.addEventListener('load', () => {
      if (mollieInstance !== null && mollieInstance !== undefined) {
        console.log('mollieInstance in PayButton 3:', mollieInstance);
      }
    });
    //return () => window.removeEventListener('load', mollieScriptLoaded);
  }
}, [mollieInstance]);



  useEffect(() => {
    // Hole wc_checkout_params aus dem globalen Kontext und setze es in den Zustand
    setCheckoutParams(window.wc_checkout_params);



   // console.log("checkoutParams: ",checkoutParams);
   // console.log("checkoutParams2: ",window.wc_checkout_params);
  }, []); // Leeres Array als zweites Argument stellt sicher, dass dieser Effekt nur einmal beim ersten Rendern ausgeführt wird




  const handleSubmitCart = async (e) => {


    console.log("HandleSubmit Cart");

    handlePayButtonClick(e);
  };



  
  const handleSubmitCart_token = async (e) => {


    console.log("HandleSubmit Cart");

    if (window.Mollie) {
      console.log("Window Mollie ok");
    }
    if(mollieInstance){
      console.log("Mollie Instance ready: ",mollieInstance);
    }

    const form = document.getElementById('ips-final-checkout-form');
    //const { token, error } = await mollieInstance.createToken(); 
    const { token, error } = mollieInstance && typeof mollieInstance.createToken === 'function'
  ? await mollieInstance.createToken()
  : { token: null, error: 'createToken function is not available' };

    console.log("HandleSubmit token made");
    console.log("The FORM: ",form);

    if (error) {
      console.error(error);
     // return;
    }

    const tokenInput = document.createElement('input');
    tokenInput.setAttribute('type', 'hidden');
    tokenInput.setAttribute('name', 'cardToken');
    tokenInput.setAttribute('value', token);

    form.appendChild(tokenInput);
    //form.submit();
    handlePayButtonClick(e);
  };



  const createFormData = (data, nonce) => {
    const formDataObj = new FormData();
    for (const [key, value] of Object.entries(data)) {
      if (Array.isArray(value)) {
        value.forEach((val, index) => formDataObj.append(`${key}[${index}]`, val));
      } else {
        formDataObj.append(key, value);
      }
      
    }
    formDataObj.append('woocommerce-process-checkout-nonce', nonce);

    return formDataObj;
  };








  const handlePayButtonClick = async (e) => {
    e.preventDefault();
    setIsValidating(true);

    try {
      if (!checkoutParams) {
        console.error('wc_checkout_params is not available');
        return;
      }

      const nonce = checkoutParams.update_order_review_nonce;
      //const formDataObj = createFormData(formData, nonce);

      //const form = document.querySelector('form.checkout');
      const form = document.querySelector('form.checkout.ips-send-order-data');
      const formDataObj = new FormData(form);

      const response = await axios.post(
        checkoutParams.checkout_url,
        formDataObj,
        {
          headers: { 'X-WC-Nonce': nonce }
        }
      );
      
      if (response.status === 200) {
        console.log("RESPONSE: ", response);
        const result = response.data;
        
        if (result.result === 'failure') {
          setIsValidating(false);
          displayErrors(result.messages);
        } else {
          document.getElementById('checkout').submit();
        }
      } else {
        console.error('Validierung fehlgeschlagen');
        setIsValidating(false);
      }
    } catch (error) {
      console.error('Fehler bei der Validierung:', error);
      setIsValidating(false);
    }
  };




  const displayErrors = (messages) => {
    const form = document.querySelector('form.checkout');

    document.querySelectorAll('.woocommerce-error, .woocommerce-message').forEach(el => el.remove());

    const errorDiv = document.createElement('div');
    errorDiv.className = 'woocommerce-NoticeGroup woocommerce-NoticeGroup-updateOrderReview';
    errorDiv.innerHTML = messages || '<div class="woocommerce-error">Es ist ein Fehler aufgetreten.</div>';
    form.prepend(errorDiv);

    const noticeGroup = form.querySelector('.woocommerce-NoticeGroup-updateOrderReview');
    if (noticeGroup) {
      window.scrollTo({ top: noticeGroup.offsetTop, behavior: 'smooth' });
    }
  };


  


  let backButton = null;
  if (checkoutsteps === 'select2') {
    backButton = <Link to="/informations" className="nav-item nav-link backarrow">&larr; Zurück</Link>;
  } else if (checkoutsteps === 'select3' && pagetype === 'payment') {
    backButton = <Link to="/ips-shipping" className="nav-item nav-link backarrow">&larr; Zurück</Link>;
  } else if (checkoutsteps === 'select3' && pagetype === 'review') {
    backButton = <Link to="/ips-payment" className="nav-item nav-link backarrow">&larr; Zurück</Link>;
  }



  const renderHiddenInputFields = () => {
    return Object.entries(formData).map(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map((val, index) => (
          <input
            key={`${key}_${index}`}
            type="hidden"
            name={`${key}[${index}]`}
            value={val}
          />
        ));
      } else {
        return <input key={key} type="hidden" name={key} value={value} />;
      }
    });
  };


  const renderHiddenMollieFields = () => {
    return Object.entries(formData).map(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map((val, index) => (
          <input
            key={`${key}_${index}`}
            type="hidden"
            name={`${key}[${index}]`}
            value={val}
          />
        ));
      } else {
        return <input key={key} type="hidden" name={key} value={value} />;
      }
    });
  };

  



  return (
    <form name="checkout" id="ips-final-checkout-form" method="post" className="checkout ips-send-order-data woocommerce-checkout" action={checkouturl ? checkouturl : undefined} encType="multipart/form-data" noValidate>


      {/* Das nonce-Feld */}
      <input type="hidden" name="woocommerce-process-checkout-nonce" value={checkoutnonce} />


      <div className="ips-checkout-terms"><BlockTerms store={store}/></div> 


      {renderHiddenInputFields()}

      <div id="ips-pay-button" className="ips-module">
        <div className="row g-3">
          <hr className="my-4" />
          <div className="col">
            {/* Ein Link zur vorherigen Seite */}
            {backButton}
          </div>
          <div className="col text-end">
            {/* Der "Jetzt bezahlen" Button */}
            <button className="btn ips-btn-primary-checkout btn-lg" type="button"  /* onClick={handlePayButtonClick}*/  onClick={handleSubmitCart}  disabled={isValidating}>
              {isValidating ? 'Bitte warten...' : 'Jetzt bezahlen'}
            </button>
          </div>
          <input type="hidden" name="legal-field" value="1" className="" />
          <input type="hidden" name="terms" value="1" className="garlic-auto-save" data-parsley-multiple="terms" />
        </div>
      </div>
    </form>
  );
};

export default PayButton;